import { marked } from "marked";
import DOMPurify from "dompurify";

const MarkdownContent = ({content}) => {
  const html = DOMPurify.sanitize(marked(content));
  return <div className="markdown-body" dangerouslySetInnerHTML={{ __html: html }} />;
}

export default MarkdownContent
